<div class="w-full flex flex-col flex-1 min-h-0">
<div class="flex flex-col flex-1 min-h-0 overflow-hidden">

  @if (loading() && !initialLoadDone()) {
    <div class="flex-1 min-h-0 flex flex-col bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
      <div class="px-6 py-5 border-b border-slate-200 bg-slate-50/50 shrink-0">
        <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div>
            <p-skeleton width="8rem" height="1.5rem" class="mb-2" />
            <p-skeleton width="14rem" height="0.875rem" />
          </div>
        </div>
      </div>
      <div class="flex-1 min-h-0 overflow-auto">
        <table class="w-full border-collapse">
          <thead class="bg-slate-50 border-b border-slate-200">
            <tr>
              <th>Cliente</th>
              <th>Monto</th>
              <th>Venta</th>
              <th>Fecha de pago</th>
              <th>Forma de pago</th>
              <th>Canal</th>
            </tr>
          </thead>
          <tbody class="bg-white divide-y divide-slate-100">
            @for (row of skeletonRows; track row) {
              <tr>
                <td class="px-2 py-2"><div class="flex items-center gap-2"><p-skeleton shape="circle" size="2.5rem" /><p-skeleton width="7rem" height="0.875rem" /></div></td>
                <td class="px-2 py-2"><p-skeleton width="6rem" height="0.875rem" /></td>
                <td class="px-2 py-2 hidden sm:table-cell"><p-skeleton width="4rem" height="0.875rem" /></td>
                <td class="px-2 py-2"><p-skeleton width="6rem" height="0.875rem" /></td>
                <td class="px-2 py-2 hidden sm:table-cell"><p-skeleton width="5rem" height="0.875rem" /></td>
                <td class="px-2 py-2 hidden sm:table-cell"><div class="flex flex-col gap-1"><p-skeleton width="4rem" height="0.875rem" /><p-skeleton width="6rem" height="0.75rem" /></div></td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      <div class="bg-slate-50 px-6 py-4 border-t border-slate-200 flex justify-between items-center shrink-0">
        <p-skeleton width="8rem" height="2rem" />
        <p-skeleton width="12rem" height="2rem" />
      </div>
    </div>
  }

  @if (error() && !loading()) {
    <div class="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
      <div class="flex items-center">
        <mat-icon class="text-red-600 mr-2">error</mat-icon>
        <p class="text-red-800">{{ error() }}</p>
      </div>
      <button
        (click)="loadPayments()"
        class="mt-3 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors">
        Reintentar
      </button>
    </div>
  }

  @if (initialLoadDone() && !error()) {
    <div class="flex-1 min-h-0 flex flex-col">
      <div class="flex-1 min-h-0 flex flex-col bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
        <div class="px-6 py-5 border-b border-slate-200 bg-slate-50/50 shrink-0">
          <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
            <div>
              <h2 class="text-lg font-semibold text-slate-900 flex items-center gap-2">
                <span class="flex h-9 w-9 items-center justify-center rounded-lg bg-sky-100 text-sky-600">
                  <i class="pi pi-wallet"></i>
                </span>
                Pagos
              </h2>
              <p class="text-sm text-slate-500 mt-1">Pagos registrados. Esta sección es de solo lectura.</p>
            </div>
            <div class="w-full sm:w-auto flex flex-wrap items-center justify-end gap-2">
              <p-button
                label="Actualizar"
                icon="pi pi-refresh"
                severity="secondary"
                size="small"
                [rounded]="true"
                [loading]="loading()"
                (onClick)="refreshTable()"
                pTooltip="Actualizar listado con los filtros y página actuales"
                tooltipPosition="left"
                appendTo="body" />
            </div>
          </div>
        </div>

        <div [formGroup]="filtersForm" class="border-b border-slate-200 bg-slate-50 shrink-0 px-3 py-2">
          <div class="grid grid-cols-2 xl:flex xl:flex-wrap xl:items-end gap-2">
            <div class="min-w-0 col-span-2 sm:col-span-1 xl:flex-1 xl:min-w-40">
              <p-floatlabel class="w-full" variant="on">
                <p-iconfield class="w-full">
                  <p-inputicon class="pi pi-search text-sm" />
                  <input pInputText id="filterPaymentQ" formControlName="q" class="w-full p-inputtext-sm" autocomplete="off" />
                  @if (filtersForm.controls.q.value) {
                    <p-inputicon class="pi pi-times text-sm cursor-pointer" (click)="filtersForm.controls.q.setValue('', { emitEvent: false }); applyFilters()" />
                  }
                </p-iconfield>
                <label for="filterPaymentQ">Cliente o RFC</label>
              </p-floatlabel>
            </div>
            <div class="min-w-0 xl:w-28">
              <p-floatlabel class="w-full" variant="on">
                <p-iconfield class="w-full">
                  <input pInputText id="filterPaymentSaleNumber" formControlName="saleNumber" class="w-full p-inputtext-sm" autocomplete="off" />
                  @if (filtersForm.controls.saleNumber.value) {
                    <p-inputicon class="pi pi-times text-sm cursor-pointer" (click)="filtersForm.controls.saleNumber.setValue('', { emitEvent: false }); applyFilters()" />
                  }
                </p-iconfield>
                <label for="filterPaymentSaleNumber">Venta</label>
              </p-floatlabel>
            </div>
            <p-floatlabel class="w-full min-w-0 xl:w-64 xl:min-w-[16rem]" variant="on">
              <p-select
                formControlName="paymentFormId"
                inputId="filterPaymentForm"
                [options]="paymentFormOptions()"
                optionLabel="description"
                optionValue="id"
                size="small"
                [showClear]="true"
                filter
                appendTo="body"
                class="w-full" />
              <label for="filterPaymentForm">Forma de pago</label>
            </p-floatlabel>
            <p-floatlabel class="w-full min-w-0 col-span-2 sm:col-span-1 xl:w-64 xl:min-w-[16rem]" variant="on">
              <p-datepicker
                inputId="filterPaymentPaidAt"
                formControlName="paidAtRange"
                selectionMode="range"
                [readonlyInput]="true"
                dateFormat="dd/mm/yy"
                showIcon
                iconDisplay="input"
                [showClear]="true"
                size="small"
                appendTo="body"
                class="w-full" />
              <label for="filterPaymentPaidAt">Fecha de pago</label>
            </p-floatlabel>
            @if (hasActiveFilters()) {
              <div class="flex items-end col-span-2 sm:col-span-1">
                <p-button
                  icon="pi pi-times"
                  [rounded]="true"
                  [text]="true"
                  size="small"
                  severity="secondary"
                  type="button"
                  (onClick)="clearFilters()"
                  ariaLabel="Limpiar filtros" />
              </div>
            }
          </div>
        </div>

        <div class="flex-1 min-h-0 overflow-hidden">
          <p-table
            [value]="payments()"
            dataKey="id"
            [lazy]="true"
            [scrollable]="true"
            scrollHeight="flex"
            [totalRecords]="totalItems()"
            [first]="currentPage() * pageSize()"
            [rows]="pageSize()"
            [rowsPerPageOptions]="pageSizeOptions"
            [showCurrentPageReport]="true"
            currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} pagos"
            [loading]="loading()"
            [paginator]="true"
            (onLazyLoad)="onLazyLoad($event)"
            [tableStyle]="{ width: '100%' }"
            styleClass="payments-primeng-table p-datatable-striped p-datatable-sm"
            [rowHover]="true"
            paginatorStyleClass="!border-0 !bg-transparent !pt-4 !flex !items-center !justify-between"
          >
            <ng-template pTemplate="paginatorleft">
              <span
                class="inline-flex"
                [pTooltip]="exportButtonTooltip"
                tooltipPosition="top"
                appendTo="body">
                <p-button
                  label="Exportar CSV"
                  icon="pi pi-download"
                  severity="secondary"
                  size="small"
                  [rounded]="true"
                  [loading]="exporting()"
                  [disabled]="!canExportPayments || exporting() || totalItems() === 0"
                  (onClick)="exportCsv()" />
              </span>
            </ng-template>
            <ng-template pTemplate="header">
              <tr>
                <th class="!px-2">Cliente</th>
                <th class="!px-2 !whitespace-nowrap !text-right">Monto</th>
                <th class="!px-2 hidden sm:table-cell !whitespace-nowrap w-[150px] min-w-[150px] max-w-[150px]" style="width: 150px">Venta</th>
                <th class="!px-2 !whitespace-nowrap !text-center">Fecha de pago</th>
                <th class="!px-2 hidden sm:table-cell !whitespace-nowrap">Forma de pago</th>
                <th class="!px-2 hidden sm:table-cell !whitespace-nowrap">Canal</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-payment>
              <tr class="cursor-pointer hover:!bg-sky-50/50 transition-colors !border-slate-100" (click)="openPaymentDetails(payment)">
                <td class="!px-2 !py-2 !border-slate-100">
                  <div class="flex items-center gap-2">
                    <div class="shrink-0 h-8 w-8 rounded-full flex items-center justify-center bg-sky-100 text-sky-600 [&>i]:text-sm">
                      <i class="pi pi-wallet"></i>
                    </div>
                    <div class="min-w-0">
                      <div class="text-sm font-medium text-slate-900 truncate">{{ getCustomerName(payment) }}</div>
                      <div class="text-xs text-slate-500 truncate">{{ payment.customer?.taxId || '' }}</div>
                    </div>
                  </div>
                </td>
                <td class="!px-2 !py-2 !border-slate-100 !whitespace-nowrap !text-right">
                  <div class="text-sm font-medium text-slate-900">{{ formatAmount(payment.amount) }}</div>
                  <div class="text-xs text-slate-500">{{ payment.currency?.code || '-' }}</div>
                </td>
                <td class="!px-2 !py-2 !border-slate-100 hidden sm:table-cell text-sm text-slate-700 w-[150px] min-w-[150px] max-w-[150px] overflow-hidden">
                  @if (payment.sale?.id) {
                    <button
                      type="button"
                      class="text-sky-600 hover:text-sky-800 hover:underline truncate max-w-full"
                      (click)="openSaleDetails(payment.sale.id, $event)">
                      {{ payment.sale.number || ('#' + payment.sale.id) }}
                    </button>
                  } @else {
                    -
                  }
                </td>
                <td class="!px-2 !py-2 !border-slate-100 text-sm text-slate-600 !whitespace-nowrap !text-center">
                  {{ formatDateTime(payment.paidAt) }}
                </td>
                <td class="!px-2 !py-2 !border-slate-100 hidden sm:table-cell text-sm text-slate-700 !whitespace-nowrap">
                  {{ getPaymentFormLabel(payment.paymentForm) || '-' }}
                </td>
                <td class="!px-2 !py-2 !border-slate-100 hidden sm:table-cell">
                  <div class="text-sm font-medium text-slate-900 truncate">{{ getPaymentProviderLabel(payment.paymentProvider) || '-' }}</div>
                  <div class="text-xs text-slate-500 truncate">{{ payment.providerId || '-' }}</div>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="6" class="!px-2 !py-12 !text-center !text-slate-500 !border-slate-100">
                  No se encontraron pagos con los filtros aplicados.
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  }

</div>

  <p-drawer
    [visible]="isDetailsOpen()"
    position="right"
    (visibleChange)="onDrawerVisibleChange($event)"
    styleClass="!w-[800px]"
    [blockScroll]="true">
    <ng-template pTemplate="header">
      <div class="flex items-center justify-between w-full border-b border-slate-200 pb-2">
        <div>
          <h3 class="text-lg font-semibold text-slate-900">Detalles del pago</h3>
          @if (selectedPayment()) {
            <p class="text-sm text-slate-500 mt-0.5">{{ getCustomerName(selectedPayment()!) }}</p>
          }
        </div>
      </div>
    </ng-template>
    @if (detailsLoading()) {
      <div class="flex flex-col items-center justify-center py-12 gap-4">
        <i class="pi pi-spin pi-spinner text-4xl text-sky-500"></i>
        <p class="text-sm text-slate-600">Cargando pago...</p>
      </div>
    } @else if (selectedPayment()) {
      <app-payment-read [payment]="selectedPayment()!" (openSale)="openSaleDetails($event)"></app-payment-read>
    }
  </p-drawer>

  <p-drawer
    [visible]="isSaleDetailsOpen()"
    position="right"
    (visibleChange)="onSaleDrawerVisibleChange($event)"
    styleClass="sale-details-drawer !w-[800px]"
    [blockScroll]="true">
    <ng-template pTemplate="header">
      <div class="flex items-center justify-between w-full gap-3">
        <div class="flex items-center gap-3 min-w-0">
          <span class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-violet-100 text-violet-600 shadow-sm">
            <i class="pi pi-shopping-cart text-base"></i>
          </span>
          <h3 class="text-lg font-semibold text-slate-900">Detalle de venta</h3>
        </div>
        @if (selectedSale() && !saleDetailsLoading()) {
          <button
            type="button"
            class="inline-flex items-center gap-2 text-sm font-semibold bg-blue-600 text-white px-3 py-2 rounded-lg shadow-sm hover:bg-blue-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 shrink-0"
            (click)="editSaleFromModal()">
            <i class="pi pi-pencil text-sm"></i>
            Editar
          </button>
        }
      </div>
    </ng-template>
    @if (saleDetailsLoading()) {
      <div class="flex flex-col items-center justify-center py-12 gap-4">
        <i class="pi pi-spin pi-spinner text-4xl text-sky-500"></i>
        <p class="text-sm text-slate-600">Cargando detalle...</p>
      </div>
    } @else if (selectedSale()) {
      <app-sale-read
        [sale]="selectedSale()!"
        [charges]="saleCharges()"
        (openCustomer)="openCustomerDetails($event)"
        (openSubscription)="openSubscriptionDetails($event)" />
    }
  </p-drawer>

  <p-drawer
    [visible]="isCustomerDetailsOpen()"
    position="right"
    (visibleChange)="onCustomerDrawerVisibleChange($event)"
    styleClass="customer-details-drawer !w-[800px]"
    [blockScroll]="true">
    <ng-template pTemplate="header">
      <div class="flex items-center justify-between w-full gap-3">
        <div class="flex items-center gap-3 min-w-0">
          <span class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-sky-100 text-sky-600 shadow-sm">
            <i class="pi pi-user text-base"></i>
          </span>
          <h3 class="text-lg font-semibold text-slate-900">Detalles del cliente</h3>
        </div>
        @if (selectedCustomer() && !customerDetailsLoading()) {
          <button
            type="button"
            class="inline-flex items-center gap-2 text-sm font-semibold bg-blue-600 text-white px-3 py-2 rounded-lg shadow-sm hover:bg-blue-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 shrink-0"
            (click)="editCustomerFromModal()">
            <i class="pi pi-pencil text-sm"></i>
            Editar
          </button>
        }
      </div>
    </ng-template>
    @if (customerDetailsLoading()) {
      <div class="flex flex-col items-center justify-center py-12 gap-4">
        <i class="pi pi-spin pi-spinner text-4xl text-sky-500"></i>
        <p class="text-sm text-slate-600">Cargando cliente...</p>
      </div>
    } @else if (selectedCustomer()) {
      <app-customer-read
        [customer]="selectedCustomer()!"
        (openSale)="openSaleDetailsFromCustomer($event)" />
    }
  </p-drawer>

  <p-drawer
    [visible]="isSubscriptionDetailsOpen()"
    position="right"
    (visibleChange)="onSubscriptionDrawerVisibleChange($event)"
    styleClass="subscription-details-drawer !w-[800px]"
    [blockScroll]="true">
    <ng-template pTemplate="header">
      <div class="flex items-center justify-between w-full gap-3">
        <div class="flex items-center gap-3 min-w-0">
          <span class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-teal-100 text-teal-600 shadow-sm">
            <i class="pi pi-sync text-base"></i>
          </span>
          <h3 class="text-lg font-semibold text-slate-900">Detalle de suscripción</h3>
        </div>
        @if (selectedSubscription() && !subscriptionDetailsLoading()) {
          <button
            type="button"
            class="inline-flex items-center gap-2 text-sm font-semibold bg-blue-600 text-white px-3 py-2 rounded-lg shadow-sm hover:bg-blue-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 shrink-0"
            (click)="editSubscriptionFromModal()">
            <i class="pi pi-pencil text-sm"></i>
            Editar
          </button>
        }
      </div>
    </ng-template>
    @if (subscriptionDetailsLoading()) {
      <div class="flex flex-col items-center justify-center py-12 gap-4">
        <i class="pi pi-spin pi-spinner text-4xl text-teal-500"></i>
        <p class="text-sm text-slate-600">Cargando suscripción...</p>
      </div>
    } @else if (selectedSubscription()) {
      <app-subscription-read
        [subscription]="selectedSubscription()!"
        (openSale)="openSaleDetailsFromCustomer($event)" />
    }
  </p-drawer>
</div>
